import { useValidateInvoicePersonDataMutation } from "src/services/cartServices";
import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Select } from "antd";
import toast from "react-hot-toast";
import { toastWarningStyle } from "src/constants";
import { Flex } from "@nubeteck/components";
import { ArrayUtils } from "@nubeteck/utils";

interface IInvoicePersonData {
  terceroNombre: string;
  terceroCorreo: string;
  terceroCedula: string;
  terceroActividadEconomica?: string;
  existeEnHacienda: boolean;
}

function ThirdPersonForm({
  savePerson,
  isLoading,
  open,
  onCancel,
  initialValues,
}: {
  savePerson: (values: IInvoicePersonData) => void;
  isLoading: boolean;
  open: boolean;
  onCancel: () => void;
  initialValues: IInvoicePersonData;
}) {
  const [formInvoiceData] = Form.useForm<IInvoicePersonData>();
  const [actividades, setActividades] = useState([]);
  const [dataValidated, setDataValidated] = useState(false);
  const { validateFields, setFieldsValue, getFieldValue } = formInvoiceData;
  const terceroActividadEconomica = getFieldValue("terceroActividadEconomica");
  const [
    validatePerson,
    {
      isLoading: isLoadingValidatePerson,
      data: personValidation,
      error: errorValidatePerson,
      isSuccess: isSuccessPersonValidation,
    },
  ] = useValidateInvoicePersonDataMutation();

  useEffect(() => {
    setFieldsValue(initialValues);
    if (initialValues?.existeEnHacienda) setDataValidated(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  useEffect(() => {
    if (errorValidatePerson && open) {
      toast.error(errorValidatePerson?.data?.message, toastWarningStyle);
      setActividades([]);
      setFieldsValue({ terceroNombre: "", terceroCorreo: "", terceroActividadEconomica: "" });
      setDataValidated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorValidatePerson]);

  useEffect(() => {
    console.log(actividades, "Actuvidad");
    console.log(terceroActividadEconomica, "Actuvidad");
  }, [actividades, terceroActividadEconomica]);

  useEffect(() => {
    if (isSuccessPersonValidation) {
      if (personValidation?.data?.legalName) {
        setActividades(personValidation?.data?.actividades);
        setDataValidated(true);
        setFieldsValue({
          terceroNombre: personValidation?.data?.legalName,
          terceroActividadEconomica: personValidation?.data?.terceroActividadEconomica,
          terceroCorreo:
            personValidation?.data?.legalName == initialValues.terceroNombre
              ? initialValues.terceroCorreo
              : "",
        });
      } else setDataValidated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personValidation, isSuccessPersonValidation]);

  const handleOkInvoicePerson = () => {
    validateFields(["terceroNombre", "terceroCorreo", "terceroCedula", "terceroActividadEconomica"])
      .then((values) => {
        if (values) {
          savePerson({ ...values, existeEnHacienda: dataValidated });
        }
      })
      .catch(() => {
        toast.error(`Algunos campos necesitan ser revisados.`);
      });
  };

  const actividadesOptions = ArrayUtils.selectLabelValue(
    actividades ?? [],
    "descripcion",
    "codigo",
  );

  return (
    <Modal
      closable={false}
      open={open}
      onOk={handleOkInvoicePerson}
      confirmLoading={isLoading}
      cancelText="Cancelar"
      okText="Guardar"
      onCancel={() => {
        onCancel();
        setFieldsValue(initialValues);
      }}
      style={{ maxWidth: 450 }}
    >
      <Form layout="vertical" form={formInvoiceData}>
        <Flex style={{ alignItems: "center", gap: 15 }}>
          <Form.Item
            name="terceroCedula"
            required
            label="Cédula"
            initialValue={initialValues?.terceroCedula}
            rules={[
              {
                required: true,
                message: "la cédula del responsable del pago es requerida.",
              },
            ]}
          >
            <Input placeholder="Cédula" size="large" />
          </Form.Item>
          <Button
            onClick={() => validatePerson(getFieldValue("terceroCedula"))}
            loading={isLoadingValidatePerson}
          >
            Validar
          </Button>
        </Flex>

        <Form.Item
          name="terceroNombre"
          label="Nombre"
          initialValue={initialValues?.terceroNombre}
          rules={[
            {
              required: true,
              message: "El nombre al que estarán registradas las facturas es requerido.",
            },
          ]}
          required
        >
          <Input placeholder="Nombre" size="large" readOnly={dataValidated} />
        </Form.Item>

        <Form.Item
          name="terceroCorreo"
          required
          label="Correo Electrónico"
          initialValue={initialValues?.terceroCorreo}
          rules={[
            {
              required: true,
              message: "Este campo es requerido.",
            },
          ]}
        >
          <Input placeholder="Correo Electrónico" size="large" />
        </Form.Item>

        {/* {actividades.length > 0 ||
        (initialValues?.terceroActividadEconomica ?? "").trim() !== "" ? ( */}

        {((terceroActividadEconomica ?? "").trim() !== "" || actividades.length > 0) && (
          <>
            <Form.Item
              name="terceroActividadEconomica"
              required
              label="Actividad económica"
              initialValue={initialValues?.terceroActividadEconomica}
              rules={[
                {
                  required: true,
                  message: "Este campo es requerido.",
                },
              ]}
            >
              <Select
                options={actividadesOptions}
                // filterOption={filterOption}
                placeholder="Seleccione una actividad"
                showSearch
                optionFilterProp="children"
                allowClear
                onChange={(e) => {
                  console.log(e);
                }}
              />
            </Form.Item>
          </>
        )}

        {/* } */}

        {/* <ButtonAlternativeStyled
          disabled={isLoadingSavingPerson || isLoadingValidatePerson}
          size="small"
          type="default"
          onClick={() => onCancel()}
        >
          Reestablecer a valores por defecto
        </ButtonAlternativeStyled> */}
      </Form>
    </Modal>
  );
}

export default ThirdPersonForm;
